(function () {
  'use strict';
  var timers = new Map();

  function enter(card, cls, msg, onConfirm) {
    exit(card);
    card.classList.add(cls);
    var el = card.querySelector('[data-mini-bag-state-message]');
    if (el) el.textContent = msg;
    timers.set(card, setTimeout(function () { timers.delete(card); onConfirm(); }, 3000));
  }

  function exit(card) {
    clearTimeout(timers.get(card));
    timers.delete(card);
    card.classList.remove('is-remove-pending', 'is-wishlist-pending');
    var el = card.querySelector('[data-mini-bag-state-message]');
    if (el) el.textContent = '';
  }

  document.addEventListener('click', function (e) {
    var strings = window.miniBAGStrings || {};
    var mb = window.miniBag;

    var rm = e.target.closest('[data-mini-bag-remove]');
    if (rm) {
      var card = rm.closest('[data-line-item-key]');
      if (!card) return;
      var key = card.dataset.lineItemKey;
      var qty = parseInt(card.querySelector('[data-mini-bag-qty-value]')?.textContent ?? '1', 10);
      enter(card, 'is-remove-pending', strings.itemRemoved || 'Item removed!',
        function () { if (mb) mb.changeQuantity(key, -qty); });
      return;
    }

    var wl = e.target.closest('[data-mini-bag-wishlist-toggle]');
    if (wl) {
      var wcard = wl.closest('[data-line-item-key]');
      if (!wcard) return;
      var wkey = wcard.dataset.lineItemKey;
      var wqty = parseInt(wcard.querySelector('[data-mini-bag-qty-value]')?.textContent ?? '1', 10);
      enter(wcard, 'is-wishlist-pending', strings.movedToWishlist || 'Moved to wishlist!',
        function () { if (window.BroraWishlist) { var wpid = Number(wl.getAttribute('data-wishlist-product-id')) || undefined; window.BroraWishlist.addItem({ product_id: wpid }).catch(function () {}); } if (mb) mb.changeQuantity(wkey, -wqty); });
      return;
    }

    var undo = e.target.closest('[data-mini-bag-undo]');
    if (undo) {
      var ucard = undo.closest('[data-line-item-key]');
      if (ucard) exit(ucard);
      return;
    }
  });
})();
